import { AxiosError } from 'axios'
import { Dispatch } from '@reduxjs/toolkit'
import { setNotification, setIsShowNotification } from 'app/state/generalSlice'
import { NavigateFunction } from 'react-router-dom'
import { APP_ROUTES } from '../components/AppRouter/routes'

export const handleServerAPIError = (
    e: AxiosError,
    dispatch: Dispatch,
    navigate: NavigateFunction,
) => {
    const statusCode = e.response?.status || 418
    const statusText = e.response?.statusText

    if (statusCode === 401) {
        navigate(APP_ROUTES.LOGIN)
    } else {
        dispatch(
            setNotification({
                type: 'error',
                header: `Server error ${statusCode}`,
                message: statusText || 'Unknown error',
            }),
        )

        dispatch(setIsShowNotification(true))
    }
}
